import { isShopTappingNodeData, } from "./graph";
import { GrindingOption, isAllowedAdditionalProcess, isAttachments, isComment, isCountersinking, isFixedRotations, isFlipSideUsage, isMaterialWithGas, isMechanicalGrinding, isTestReport, isThreading, } from "./articleeditdata";
import { isEqual, } from "./aux";
import { articleEditData, isManufacturablePartBase, } from "./documentdialog";
import { isNumber, isString, isTubeCuttingParams, } from "./wsi4_typeguards";
function mergeAttributes(lhs, rhs) {
    return {
        ...lhs,
        ...rhs,
    };
}
function mergeAdditionalProcesses(lhs, rhs) {
    return [
        ...lhs,
        ...rhs,
    ];
}
function mergeData(lhs, rhs) {
    if (lhs.vertexKey !== rhs.vertexKey) {
        throw Error("VertexKeys do not match");
    }
    return {
        vertexKey: lhs.vertexKey,
        attributes: mergeAttributes(lhs.attributes, rhs.attributes),
        additionalProcesses: mergeAdditionalProcesses(lhs.additionalProcesses, rhs.additionalProcesses),
    };
}
export function merge(data) {
    return data.reduce((arr, entry) => {
        const i = arr.findIndex(d => d.vertexKey === entry.vertexKey);
        if (i === -1) {
            arr.push(entry);
        }
        else {
            arr[i] = mergeData(arr[i], entry);
        }
        return arr;
    }, []);
}
export function convertToWsi4Data(projectEntry, newData, shopConfig) {
    const oldData = articleEditData(projectEntry, shopConfig);
    const data = newData.filter((datum, index) => !isEqual(datum.value, oldData[index].value))
        .reduce((arr, datum) => {
        switch (datum.key) {
            case "articleExternalDrawingNumber": {
                if (!isString(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        articleExternalDrawingNumber: datum.value,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "articleExternalPartNumber": {
                if (!isString(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        articleExternalPartNumber: datum.value,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "articleExternalRevisionNumber": {
                if (!isString(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        articleExternalRevisionNumber: datum.value,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "articleName": {
                if (!isString(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        articleName: datum.value,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "attachments": {
                if (!isAttachments(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        attachments: datum.value.attachments,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "comment": {
                if (!isComment(datum.value)) {
                    throw new Error("Wrong type");
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        comment: datum.value.comment,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "countersinking": {
                if (!isCountersinking(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                if (!isAllowedAdditionalProcess("countersinking", shopConfig)) {
                    throw new Error("Missing process");
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {},
                    additionalProcesses: [
                        {
                            process: "countersinking",
                            addNode: datum.value.numCounterSinks !== 0,
                            userDataEntries: [
                                {
                                    key: "numCountersinks",
                                    value: datum.value.numCounterSinks,
                                },
                            ],
                        },
                    ],
                });
                break;
            }
            case "fixedRotations": {
                if (!isFixedRotations(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        fixedRotations: datum.value.rotations,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "flipSideUsage": {
                if (!isFlipSideUsage(datum.value)) {
                    throw new Error("Wrong type");
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        flipSide: datum.value.flipSide,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "materialWithGas": {
                if (!isManufacturablePartBase(projectEntry)) {
                    throw new Error("Wrong projectEntry type for key " + datum.key);
                }
                if (!isMaterialWithGas(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        sheetMaterial: datum.value.material,
                    },
                    additionalProcesses: [],
                });
                arr.push({
                    vertexKey: projectEntry.vertexKeyOfSheetCutting,
                    attributes: {
                        cuttingGas: datum.value.cuttingGasId,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "mechanicalGrinding": {
                if (!isMechanicalGrinding(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                if (!isAllowedAdditionalProcess("mechanicalGrinding", shopConfig)) {
                    throw new Error("Missing process");
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {},
                    additionalProcesses: [
                        {
                            process: "mechanicalDeburring",
                            addNode: datum.value.option === GrindingOption.doubleSidedMechanicalDeburring || datum.value.option === GrindingOption.singleSidedMechanicalDeburring,
                            userDataEntries: [
                                {
                                    key: "deburrDoubleSided",
                                    value: datum.value.option === GrindingOption.doubleSidedMechanicalDeburring,
                                },
                            ],
                        },
                        {
                            process: "slideGrinding",
                            addNode: datum.value.option === GrindingOption.slideGrinding,
                            userDataEntries: [],
                        },
                    ],
                });
                break;
            }
            case "multiplicity": {
                if (!isNumber(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        importMultiplicity: datum.value,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "testReport": {
                if (!isTestReport(datum.value)) {
                    throw new Error("Wrong type");
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        testReportRequired: datum.value.required,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "thickness": {
                if (!isNumber(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        thickness: datum.value,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "threading": {
                if (!isThreading(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                if (!isAllowedAdditionalProcess("threading", shopConfig)) {
                    throw new Error("Missing process");
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {},
                    additionalProcesses: [
                        {
                            process: "threading",
                            addNode: datum.value.numThreads !== 0,
                            userDataEntries: [
                                {
                                    key: "numThreads",
                                    value: datum.value.numThreads,
                                },
                            ],
                        },
                    ],
                });
                break;
            }
            case "tubeCuttingData": {
                if (!isTubeCuttingParams(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {
                        tubeCuttingEditParams: datum.value,
                    },
                    additionalProcesses: [],
                });
                break;
            }
            case "tapping": {
                if (!isShopTappingNodeData(datum.value)) {
                    throw new Error("Wrong type for key " + datum.key);
                }
                if (!isAllowedAdditionalProcess("tapping", shopConfig)) {
                    throw new Error("Missing process");
                }
                arr.push({
                    vertexKey: datum.vertexKey,
                    attributes: {},
                    additionalProcesses: [
                        {
                            process: "tapping",
                            addNode: datum.value.selection.length > 0,
                            userDataEntries: [
                                {
                                    key: "sheetTappingData",
                                    value: datum.value.selection,
                                },
                            ],
                        },
                    ],
                });
                break;
            }
            default: throw Error("Missing case handling: " + datum.key);
        }
        return arr;
    }, []);
    return merge(data);
}
